export const fmt = (n) =>
  n.toLocaleString("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 });

const sliderClass =
  "w-full h-[2px] bg-black/10 rounded-full appearance-none cursor-pointer accent-[#DBB89C]";

export const SliderField = ({ label, display, min, max, step, value, onChange, testid }) => (
  <div>
    <div className="flex items-baseline justify-between mb-4">
      <label className="text-xs font-semibold tracking-[0.25em] uppercase text-[#908B85]">
        {label}
      </label>
      <span data-testid={`${testid}-value`} className="font-display text-2xl">
        {display}
      </span>
    </div>
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      data-testid={`${testid}-slider`}
      className={sliderClass}
    />
  </div>
);

export const ResultCard = ({ repayment, freq, totalInterest, totalPaid }) => (
  <>
    <div className="bg-white rounded-[4px] border border-black/[0.08] p-10 md:p-14 shadow-[0_4px_40px_-10px_rgba(0,0,0,0.06)]">
      <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#908B85] mb-3">
        Estimated repayment
      </p>
      <p
        data-testid="calculator-repayment-result"
        className="font-display font-medium text-5xl sm:text-6xl lg:text-7xl tracking-tight text-[#CFAEA5]"
      >
        {fmt(repayment)}
      </p>
      <p className="mt-2 text-sm text-[#908B85] capitalize">{freq}</p>
      <div className="mt-10 pt-8 border-t border-black/[0.08] space-y-4 text-sm">
        <div className="flex justify-between">
          <span className="text-[#908B85]">Total interest payable</span>
          <span data-testid="calculator-total-interest" className="font-medium">
            {fmt(totalInterest)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-[#908B85]">Total amount repaid</span>
          <span data-testid="calculator-total-paid" className="font-medium">
            {fmt(totalPaid)}
          </span>
        </div>
      </div>
      <a
        href="#contact"
        data-testid="calculator-cta-link"
        className="mt-10 inline-flex items-center gap-3 text-xs font-semibold tracking-[0.3em] uppercase text-[#493E38] border-b border-[#A9ADA1] pb-2 hover:text-[#CFAEA5] transition-colors duration-300"
      >
        Talk these numbers through
      </a>
    </div>
    <p className="mt-6 text-xs tracking-wide text-[#908B85] leading-relaxed">
      Estimates only, based on principal-and-interest repayments at a constant
      rate. Actual repayments depend on your lender, loan structure and fees.
    </p>
  </>
);
